import { oc } from '@orpc/contract';
import { idParamSchema } from '../../common/schemas/id.schemas.js';
import { scenarioSchema } from '../schemas/scenarios.schemas.js';
export const toggleScenarioStatusContract = oc
    .route({
    method: 'POST',
    path: '/scenarios/{id}/toggle-status',
    tags: ['Scenarios'],
    summary: 'Flip a scenario between ACTIVE and INACTIVE',
    description: 'MANAGER only.',
})
    .input(idParamSchema)
    .output(scenarioSchema);
//# sourceMappingURL=toggle-scenario-status.contract.js.map